import { Activity } from '@/features/course/admin/types/activity';

export const getNextOrderIndex = (activities: Activity[]): number =>
  (Math.max(...activities.map((activity) => activity.order)) || 0) + 1;
